export const isSubmitButtonDisabled = (
  isLoading: boolean,
  isOtpVisible: boolean,
  otpCode?: string,
) => {
  return ((!otpCode || otpCode.length !== 9) && isOtpVisible) || isLoading;
};
